import { render, staticRenderFns } from "./InstagramModal.vue?vue&type=template&id=719069cc&scoped=true"
import script from "./InstagramModal.vue?vue&type=script&lang=js"
export * from "./InstagramModal.vue?vue&type=script&lang=js"
import style0 from "./InstagramModal.vue?vue&type=style&index=0&id=719069cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719069cc",
  null
  
)

export default component.exports